<template>
    <div :class="alignClasses">

        <v-tooltip v-if="editMode && false" top color="primary" nudge-bottom="100" :open-delay="400" :close-delay="400">
            <template v-slot:activator="{ on }">
                <v-scale-transition>
                    <v-img v-on="on"
                           v-show="logo"
                           :src="logo"
                           :aspect-ratio="aspectRatio"
                           :max-width="size"
                           :max-height="height"
                           contain
                    />
                </v-scale-transition>
            </template>
            <span>This logo can be changed in sub panel settings</span>
        </v-tooltip>

        <!-- NON EDIT MODE -->
        <v-scale-transition v-else>
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">
                    <v-img
                        v-show="logo"
                        v-on="on"
                        :src="logo"
                        :aspect-ratio="aspectRatio"
                        :max-width="size"
                        :max-height="height"
                        contain
                    />
                </template>
                This logo can be edited in the sub panel settings
            </v-tooltip>
        </v-scale-transition>

    </div>
</template>

<script>

export default {

    components: {},

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        logo: {
            type: String | null,
            required: false,
        },
        size: {
            type: Number | null,
            required: false,
            default: 900,
        },
        align: {
            type: String | null,
            required: false,
            default: 'left'
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    computed: {
        aspectRatio() {
            return this.size / +this.height;
        },

        height() {
            return Math.round(this.size * 300 / 900);
        },

        alignClasses() {

            let classes = ['d-flex'];

            if (this.align === "left") classes.push("justify-start");
            if (this.align === "right") classes.push("justify-end");
            if (this.align === "center") classes.push("justify-center");

            // Allow borderless logo on max size
            if (this.size !== 900) {
                classes.push("pa-5")
            }

            return classes.join(' ');
        }
    }
}
</script>
